// 修改更改状态
export const CHANGE_UPDATE_STATE = 'CHANGE_UPDATE_STATE';
// 修改黑名单类型：公共/学校
export const CHANGE_BLACK_TYPE = 'CHANGE_BLACK_TYPE';
/**
 * 宿管
 */
// 修改修改状态：宿舍信息是否被修改/删除
export const SWITCH_IS_CHANGED = 'SWITCH_IS_CHANGED';
// 修改住宿生页面状态：是否从宿舍房间页面跳转过来
export const SWITCH_IS_FROM_ROOM = 'SWITCH_IS_FROM_ROOM';
// 修改住宿房间页面状态：是否从宿舍楼页面跳转过来
export const SWITCH_IS_FROM_DORM = 'SWITCH_IS_FROM_DORM';
// 上面两种状态改变时，设置筛选项的值
export const SET_SELECT_DATA = 'SET_SELECT_DATA';
